/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsAdvertisementOptionsWeChatFromJSON, FxIdDomainSettingsAdvertisementOptionsWeChatToJSON, } from './FxIdDomainSettingsAdvertisementOptionsWeChat';
import { FxIdDomainSettingsAdvertisementOptionsYandexFromJSON, FxIdDomainSettingsAdvertisementOptionsYandexToJSON, } from './FxIdDomainSettingsAdvertisementOptionsYandex';
import { FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesFromJSON, FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesToJSON, } from './FxIdDomainSettingsAdvertisementOptionsFacebookInstantGames';
import { FxIdDomainSettingsAdvertisementOptionsGtagFromJSON, FxIdDomainSettingsAdvertisementOptionsGtagToJSON, } from './FxIdDomainSettingsAdvertisementOptionsGtag';
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementOptions(value) {
    return true;
}
export function FxIdDomainSettingsAdvertisementOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Yandex': json['Yandex'] == null ? undefined : FxIdDomainSettingsAdvertisementOptionsYandexFromJSON(json['Yandex']),
        'FacebookInstantGames': json['FacebookInstantGames'] == null ? undefined : FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesFromJSON(json['FacebookInstantGames']),
        'WeChat': json['WeChat'] == null ? undefined : FxIdDomainSettingsAdvertisementOptionsWeChatFromJSON(json['WeChat']),
        'Gtag': json['Gtag'] == null ? undefined : FxIdDomainSettingsAdvertisementOptionsGtagFromJSON(json['Gtag']),
    };
}
export function FxIdDomainSettingsAdvertisementOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Yandex': FxIdDomainSettingsAdvertisementOptionsYandexToJSON(value['Yandex']),
        'FacebookInstantGames': FxIdDomainSettingsAdvertisementOptionsFacebookInstantGamesToJSON(value['FacebookInstantGames']),
        'WeChat': FxIdDomainSettingsAdvertisementOptionsWeChatToJSON(value['WeChat']),
        'Gtag': FxIdDomainSettingsAdvertisementOptionsGtagToJSON(value['Gtag']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementOptions.js.map